import { Injectable } from "../../../../node_modules/@angular/core";
import { ApiService } from "@app/core/services/api.service";
import { Observable } from "../../../../node_modules/rxjs";
import { map } from "../../../../node_modules/rxjs/operators";


export interface SendCodeContext {
    EmailAddress: string;
  }
  
  export interface VerifyCodeContext {
    EmailAddress: string;
    VerificationCode: number;
  }
  


@Injectable()
export class CommonService {

    constructor (private apiService: ApiService) {}

    validateLink(uuid: string) : Observable<any> {
        const data ={'uuid': uuid};
        return this.apiService.get('/verify/link/'+uuid)
        .pipe(
            map(
                res => {
                //console.log("response"+ res);          
                return res
                },
                err => {
                console.log("error response"+ err);
                }
            )
        );
    }

    sendCode(context: SendCodeContext): Observable<any> {
        const data = { "emailAddress": context.EmailAddress };
        return this.apiService.post('/send/code', data)
          .pipe(
            map(
              res => {
                //console.log("response" +  res);
                return res
              },
              err => {
                console.log("error response" + err);
              }
            )
          );
      }
        verifyCode(context: VerifyCodeContext): Observable<any> {
        const data = { "emailAddress": context.EmailAddress, "verificationCode": context.VerificationCode };
        return this.apiService.post('/verify/code', data)
          .pipe(
            map(
              res => {
                //console.log("response" +  res);
                return res
              },
              err => {
                console.log("error response" + err);
              }
            )
          );
      }
}